import { ToggleButtonProps } from "react-aria-components";
import { ReactNode } from "react";

export enum MDSToggleButtonGroupItemSlotName {
  LeftIcon = "leftIcon",
  RightIcon = "rightIcon",
}

export interface IMDSToggleButtonGroupItemProps extends ToggleButtonProps {
  ariaLabel: string;
  children?: ReactNode;
}
